import gql from 'graphql-tag';

export const KYB_REFUSAL_TAG_QUERY = gql`
  query kybRefusalTagQuery($companyProfileId: ID!) {
    viewer {
      uid
      company: application(companyProfileId: $companyProfileId) {
        applicationId
        companyProfileId
        lastKybReview {
          kybReviewId
          error
          refusalTag
        }
      }
    }
  }
`;
